export default "__VITE_ASSET__D66LrTyT__"